import React from 'react';

const TablePagination = ({
  currentPage,
  totalPages,
  totalCount,
  showingFrom,
  showingTo,
  onPageChange,
  className = '',
}) => {
  if (totalCount === 0) return null;

  if (totalPages <= 1) {
    return (
      <div className={`text-muted small pt-2 ${className}`}>
        {totalCount} {totalCount === 1 ? 'row' : 'rows'}
      </div>
    );
  }

  return (
    <div className={`d-flex justify-content-between align-items-center flex-wrap gap-2 pt-3 ${className}`}>
      <span className="text-muted small">
        Showing {showingFrom}–{showingTo} of {totalCount}
      </span>
      <div className="btn-group btn-group-sm">
        <button
          type="button"
          className="btn btn-outline-secondary"
          disabled={currentPage <= 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          Prev
        </button>
        <span className="btn btn-outline-secondary disabled">
          Page {currentPage} of {totalPages}
        </span>
        <button
          type="button"
          className="btn btn-outline-secondary"
          disabled={currentPage >= totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default TablePagination;
